import ColleaguesManageTable from './ColleaguesManageTable.component';

export default ColleaguesManageTable;